// extracted by mini-css-extract-plugin
export var md = "_34-4";
export var semantic = "_34-5";
export var sm = "_34-3";
export var text = "_34-6";
export var toggleInput = "_34-0";
export var toggleSwitch = "_34-1";
export var xs = "_34-2";